import React from "react";

/**
 * Mechanism — rendered as a three-column code panel.
 * Same visual language as the AccessGrid: monospace, hairline chrome.
 */
export function MechanismCards() {
  return (
    <div className="mkt-fig-code" data-testid="mkt-mechanism-cards" role="region" aria-label="The mechanism">
      <div className="mkt-fig-code-head">
        <span>foundation.mechanism</span>
        <span>runtime = client_infra</span>
      </div>

      <div className="mkt-fig-code-cols">
        {/* Column 1 — entity resolution */}
        <div className="mkt-fig-code-col">
          <div className="mkt-fig-code-col-head">foundation.resolve</div>
          <div className="mkt-fig-code-comment">who is the party behind three filings?</div>
          <div className="mkt-fig-code-line">→ <strong>resolved</strong> to one true entity.</div>
          <div className="mkt-fig-code-line">→ three records reconciled.</div>
          <div className="mkt-fig-code-line">→ audit_trail retained.</div>
        </div>

        {/* Column 2 — access model */}
        <div className="mkt-fig-code-col">
          <div className="mkt-fig-code-col-head">foundation.access</div>
          <div className="mkt-fig-code-line">
            <span className="mkt-fig-chip grant">GRANT</span>
            the systems a workload needs.
          </div>
          <div className="mkt-fig-code-line">
            <span className="mkt-fig-chip deny">DENY</span>
            everything else, by default.
          </div>
          <div className="mkt-fig-code-line">
            <span className="mkt-fig-chip enforce">ENFORCE</span>
            at the moment records resolve.
          </div>
        </div>

        {/* Column 3 — build and transfer */}
        <div className="mkt-fig-code-col">
          <div className="mkt-fig-code-col-head">deployment.transfer</div>
          <div className="mkt-fig-code-line"><strong>substrate</strong> = in_country</div>
          <div className="mkt-fig-code-line"><strong>keys</strong> = customer_held</div>
          <div className="mkt-fig-code-line emerald"><strong>ownership</strong> = transferred_to_you</div>
        </div>
      </div>
    </div>
  );
}
